





import { Vue } from 'vue-property-decorator';
export default class Faq extends Vue {}
